import { Stack, router } from 'expo-router';

import { Button, Text, VStack } from '@squire/ui';

import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { ErrorBoundaryProps } from './types';

export default function ErrorBoundary({ error }: ErrorBoundaryProps) {
  const { t } = useScreenTranslations('app');

  const handleGoHome = () => {
    router.replace('/');
  };

  return (
    <VStack style={styles.container}>
      <Stack.Screen options={{ title: t('error.title') }} />
      <Text style={styles.title}>{t('error.title')}</Text>
      <Text style={styles.message}>{error.message || t('error.message')}</Text>
      <Button variant="primary" onPress={handleGoHome} style={styles.button}>
        {t('error.takeMeHome')}
      </Button>
    </VStack>
  );
}
